import { render } from "./CurbsCreating.vue?vue&type=template&id=089a0079&ts=true"
import script from "./CurbsCreating.vue?vue&type=script&lang=ts"
export * from "./CurbsCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__